import type { SVGProps } from 'react'
import { cn } from '#core/utils/cn.ts'

/** A faint ring with a darker arc turning around it, both in `currentColor`; the host sizes it and names the busy state. */
export function LoadingSpinner({ className, ...rest }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={cn('ynt-loading-spinner', className)}
      viewBox="0 0 24 24"
      aria-hidden="true"
      {...rest}
    >
      <circle className="ynt-loading-spinner-track" />
      <circle className="ynt-loading-spinner-arc" />
    </svg>
  )
}

export default LoadingSpinner
